module.exports = __webpack_public_path__ + "949b8288624723318edc8b1cf3d0a0b2.png";